import type { Weekday } from "../api";
import type { SchedulerTimeSlotFormValues } from "../types/schedulerTypes";

export function hasOverlappingTimeSlots(timeSlots: SchedulerTimeSlotFormValues[]): boolean {
    const byWeekday = new Map<Weekday, { start: string; end: string }[]>();

    for (const slot of timeSlots) {
        if (!slot.weekday || !slot.start || !slot.end) continue;
        const list = byWeekday.get(slot.weekday) ?? [];
        list.push({start: slot.start, end: slot.end});
        byWeekday.set(slot.weekday, list);
    }

    for (const list of byWeekday.values()) {
        const sorted = [...list].sort((a, b) => a.start.localeCompare(b.start));
        for (let i = 0; i < sorted.length - 1; i++) {
            if (sorted[i].end > sorted[i + 1].start) {
                return true;
            }
        }
    }

    return false;
}
